// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body .tags{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.body h2{
    font-weight: 600;
    color: #333;
}


.customer-table {
  /* overflow-x: auto; */
  white-space: nowrap;
  overflow-y: visible;
}

.customer-table table{
  width: 100%;
  min-width: 600px; /* Ensures table doesn't get too compressed */
}

@media (max-width: 840px) {
  .customer-table {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  }
  
  .customer-table table {
    min-width: 700px; /* Minimum width to trigger horizontal scroll */
  }
}

.addbtn {
    display: flex;
    gap: 10px;
    align-items: center;
    position: relative;
    margin-right: 10px;
}

.addbtn input {
    flex: 1 1;
    padding: 10px 160px 10px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.addbtn button {
    position: absolute;
    right: 0;
    height: 60%;
    border: none;
    padding: 0 15px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.addbtn button:first-of-type {
    right: 85px;
    background-color: #0A4DA2;
    color: #fff;
    border-radius: 4px;
}

.addbtn button:last-of-type {
    right: 10px;
    background-color: #b7b6b6d6;
    border-left: none;
    color: #333;
    border-radius: 4px;
}

.addbtn button:hover {
    opacity: 0.9;
}

@media (max-width: 480px) {
    .addbtn {
        flex-direction: column;
        position: static;
        gap: 10px;
        margin-right: 0;
    }

    .addbtn input {
        width: 100%;
        padding: 10px;
    }

    .addbtn button {
        position: static;
        width: 100%;
        height: 40px;
        padding: 10px 15px;
    }

    .addbtn button:first-of-type {
        right: auto;
    }

    .addbtn button:last-of-type {
        right: auto;
    }
}

.body .tags .tagLists{
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 30px;
    align-items: flex-start;
}

.body .tags .tagLists li{
    list-style: none;
    font-weight: 500;
    padding: 10px 15px;
    border: 1px solid #e0e0e0;
    border-radius: 24px;
    box-shadow: 0 2px 8px rgba(10, 77, 162, 0.12);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: max-content;
    background: linear-gradient(135deg, #f5f7fa 0%, #f0f3f8 100%);
    cursor: default;
    text-align: center;
    margin-bottom: 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
}

.body .tags .tagLists li:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(10, 77, 162, 0.18);
    border-color: #0A4DA2;
}

.body .tags .tagLists li span {
    white-space: nowrap;
    color: #333;
}

.tag-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: 4px;
}

.body .tags .tagLists li .remove-tag {
    background: none;
    border: none;
    color: #888;
    cursor: pointer;
    padding: 4px;
    margin-left: 2px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    border-radius: 50%;
}

.body .tags .tagLists li .remove-tag:hover {
    color: #d32f2f;
    background-color: rgba(211, 47, 47, 0.1);
}

.body .tags .tagLists li .remove-tag:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.permission-modal .modal-tags-container label{
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    margin-top: 0;
}

.modal-tags-container .tags {
    max-height: 300px;
    overflow-y: auto;
}

.modal-tags-container .tags .tagLists {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0;
    margin: 0;
}

.modal-tags-container .addbtn{
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 20px;
    justify-content: flex-end;
    align-items: center;
}

/* Tag Dropdown Styles */

.tag-selector-wrapper {
    display: flex;
    gap: 15px;
    align-items: flex-start;
    margin-top: 10px;

    @media (max-width: 767px) {
        flex-direction: column;
        gap: 10px;
        
    }
}

.permission-selector-wrapper{
    display: flex;
    gap: 15px;
    align-items: flex-start;
    margin-top: 10px;
    flex-direction: column;
}
.permission-dropdown-wrapper{
    position: relative;
    width: 100%;

    @media (max-width: 767px) {
        flex: none;
        width: 100%;
    }
}
.tag-dropdown-wrapper {
    position: relative;
    flex: 0 0 300px;
    width: 300px;

    @media (max-width: 767px) {
        flex: none;
        width: 100%;
    }
}

.tag-dropdown-select {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: none;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    padding: 0 20px;
    background-color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333;
    box-sizing: border-box;
}

.tag-dropdown-select:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
}

.dropdown-arrow {
    color: #666;
}

.permission-dropdown-menu{
    margin-top: 5px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 250px;
    overflow-y: auto;
}

.tag-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 5px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 250px;
    overflow-y: auto;
    z-index: 1000;
}   

.tag-dropdown-item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    cursor: pointer;
    transition: background-color 0.2s;
    gap: 10px;
}

.tag-dropdown-item:hover {
    background-color: #f5f5f5;
}

.tag-dropdown-item input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    margin: 0;
    accent-color: #0A4DA2;
}

.tag-dropdown-item span {
    color: #333;
    font-weight: 500;
}

/* Inline Tags Display */
.tags-inline {
    flex: 1 1;
    min-width: 0;
}

.tags-inline .tagLists {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 0;
    padding: 0;
}

.tags-inline .tagLists li {
    list-style: none;
    font-weight: 500;
    padding: 8px 12px;
    border: 1px solid #9b999944;
    border-radius: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #f5f5f5;
}

.tags-inline .tagLists li svg {
    color: #4CAF50;
    height: 16px;
    width: 16px;
}

.tags-inline .tagLists li .remove-tag {
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 0;
    margin-left: 4px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s;
}

.tags-inline .tagLists li .remove-tag:hover {
    color: #ff0000;
}

.modal-tags-container label{
    margin-top: 50px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: flex-start;
}
.modal-tags-container input{
    height: 50px;
    border-radius: 30px;
    border: none;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    padding: 20px;
    width: clamp(200px, 90vw, 670px);
    /* max-width: 350px; */
    box-sizing: border-box;
}

@media (max-width: 480px) {
    .modal-tags-container .addbtn {
        flex-direction: column;
        gap: 10px;
        margin-top: 10px;
    }

    .modal-tags-container input {
        width: 100%;
        height: 45px;
        padding: 15px;
        border-radius: 8px;
    }
    
    .tag-selector-wrapper {
        flex-direction: column;
        gap: 10px;
    }
    
    .tag-dropdown-wrapper {
        flex: none;
        width: 100%;
    }
    
    .tag-dropdown-select {
        height: 45px;
        padding: 0 15px;
        border-radius: 8px;
    }
    
    .tag-dropdown-menu {
        max-height: 200px;
    }
    
    .tags-inline {
        width: 100%;
    }
}
.modal-tags-container .tags .tagLists li {
    list-style: none;
    font-weight: 500;
    padding: 8px 12px;
    border: 1px solid #9b999944;
    border-radius: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #f5f5f5;
}

.modal-tags-container .tags .tagLists li svg {
    color: #4CAF50;
    height: 18px;
    width: 18px;
}

.modal-tags-container .tags .tagLists li .remove-tag {
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 0;
    margin-left: 4px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s;
}

.modal-tags-container .tags .tagLists li .remove-tag:hover {
    color: #ff0000;
}

/* Tag Actions Container */
.tag-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-left: auto;
}

/* Edit Tag Button */
.edit-tag-btn {
    background: none;
    border: none;
    color: #0A4DA2;
    cursor: pointer;
    padding: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    border-radius: 50%;
}

.edit-tag-btn:hover {
    color: #063d7a;
    background-color: rgba(10, 77, 162, 0.1);
}

.edit-tag-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Edit Tag Container */
.edit-tag-container {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 2px;
}

.edit-tag-input {
    flex: 1 1;
    padding: 8px 12px;
    border: 2px solid #0A4DA2;
    border-radius: 8px;
    outline: none;
    min-width: 120px;
    font-size: 14px;
    font-weight: 500;
    background-color: #fff;
    transition: all 0.3s ease;
}

.edit-tag-input:focus {
    border-color: #063d7a;
    box-shadow: 0 0 0 3px rgba(10, 77, 162, 0.15);
    background-color: #f9fbff;
}

.edit-tag-input:disabled {
    opacity: 0.6;
    background-color: #f5f5f5;
}

.save-edit-btn,
.cancel-edit-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    border-radius: 4px;
}

.save-edit-btn {
    color: #4CAF50;
}

.save-edit-btn:hover {
    color: #2e7d32;
    background-color: rgba(76, 175, 80, 0.1);
}

.save-edit-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.cancel-edit-btn {
    color: #f44336;
}

.cancel-edit-btn:hover {
    color: #c62828;
    background-color: rgba(244, 67, 54, 0.1);
}

.cancel-edit-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.modal-tags-container .tags .tagLists li.editing {
    padding: 6px 10px;
    background-color: #f0f7ff;
    /* border-color: #0A4DA2; */
}

.body .tags .tagLists li svg{
    color: #4CAF50;
    height: 25px;
    width: 25px;
}

@media (max-width: 768px) {
    .body h2 {
        text-align: center;
    }

    .body .tags .tagLists {
        gap: 8px;
        margin-top: 20px;
        padding: 0 10px;
    }

    .body .tags .tagLists li {
        padding: 8px 12px;
    }

    .body .tags .tagLists li svg {
        height: 20px;
        width: 20px;
    }

    .modal-tags-container .tags {
        max-height: 250px;
    }

    .modal-tags-container .tags .tagLists {
        gap: 8px;
    }

    .modal-tags-container .tags .tagLists li {
        padding: 6px 10px;
    }

    .modal-tags-container .tags .tagLists li svg {
        height: 16px;
        width: 16px;
    }

    .modal-tags-container .tags .tagLists li .remove-tag {
        width: 18px;
        height: 18px;
    }

    .edit-tag-btn {
        width: 18px;
        height: 18px;
    }

    .edit-tag-input {
        padding: 5px 8px;
        min-width: 80px;
    }

    .save-edit-btn,
    .cancel-edit-btn {
    }
}

    .body .tags .tagLists {
        gap: 10px;
        padding: 0 5px;
    }

    .body .tags .tagLists li {
        padding: 15px;
    }

    .modal-tags-container input {
        height: 40px;
        padding: 12px;
    }

    .modal-tags-container .addbtn button {
        height: 40px;
    }

    .edit-tag-container {
        gap: 4px;
    }

    .edit-tag-input {
        padding: 4px 6px;
        min-width: 60px;
    }

.tag-actions {
    gap: 2px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/tags.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;;AAGA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC,EAAE,4BAA4B;EACjE;;EAEA;IACE,gBAAgB,EAAE,+CAA+C;EACnE;AACF;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,sBAAsB;QACtB,gBAAgB;QAChB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,6DAA6D;IAC7D,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;;IAEhB;QACI,sBAAsB;QACtB,SAAS;;IAEb;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;;IAEX;QACI,UAAU;QACV,WAAW;IACf;AACJ;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;;IAEZ;QACI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;IACtC,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;AACJ;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;IAEA;AACJ;;IAEI;QACI,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;AAEJ;IACI,QAAQ;AACZ","sourcesContent":[".body .tags{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n}\n\n.body h2{\n    font-weight: 600;\n    color: #333;\n}\n\n\n.customer-table {\n  /* overflow-x: auto; */\n  white-space: nowrap;\n  overflow-y: visible;\n}\n\n.customer-table table{\n  width: 100%;\n  min-width: 600px; /* Ensures table doesn't get too compressed */\n}\n\n@media (max-width: 840px) {\n  .customer-table {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n  }\n  \n  .customer-table table {\n    min-width: 700px; /* Minimum width to trigger horizontal scroll */\n  }\n}\n\n.addbtn {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    position: relative;\n    margin-right: 10px;\n}\n\n.addbtn input {\n    flex: 1;\n    padding: 10px 160px 10px 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n}\n\n.addbtn button {\n    position: absolute;\n    right: 0;\n    height: 60%;\n    border: none;\n    padding: 0 15px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.addbtn button:first-of-type {\n    right: 85px;\n    background-color: #0A4DA2;\n    color: #fff;\n    border-radius: 4px;\n}\n\n.addbtn button:last-of-type {\n    right: 10px;\n    background-color: #b7b6b6d6;\n    border-left: none;\n    color: #333;\n    border-radius: 4px;\n}\n\n.addbtn button:hover {\n    opacity: 0.9;\n}\n\n@media (max-width: 480px) {\n    .addbtn {\n        flex-direction: column;\n        position: static;\n        gap: 10px;\n        margin-right: 0;\n    }\n\n    .addbtn input {\n        width: 100%;\n        padding: 10px;\n    }\n\n    .addbtn button {\n        position: static;\n        width: 100%;\n        height: 40px;\n        padding: 10px 15px;\n    }\n\n    .addbtn button:first-of-type {\n        right: auto;\n    }\n\n    .addbtn button:last-of-type {\n        right: auto;\n    }\n}\n\n.body .tags .tagLists{\n    text-decoration: none;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 30px;\n    align-items: flex-start;\n}\n\n.body .tags .tagLists li{\n    list-style: none;\n    font-weight: 500;\n    padding: 10px 15px;\n    border: 1px solid #e0e0e0;\n    border-radius: 24px;\n    box-shadow: 0 2px 8px rgba(10, 77, 162, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    width: max-content;\n    background: linear-gradient(135deg, #f5f7fa 0%, #f0f3f8 100%);\n    cursor: default;\n    text-align: center;\n    margin-bottom: 0;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n}\n\n.body .tags .tagLists li:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(10, 77, 162, 0.18);\n    border-color: #0A4DA2;\n}\n\n.body .tags .tagLists li span {\n    white-space: nowrap;\n    color: #333;\n}\n\n.tag-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-left: 4px;\n}\n\n.body .tags .tagLists li .remove-tag {\n    background: none;\n    border: none;\n    color: #888;\n    cursor: pointer;\n    padding: 4px;\n    margin-left: 2px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    border-radius: 50%;\n}\n\n.body .tags .tagLists li .remove-tag:hover {\n    color: #d32f2f;\n    background-color: rgba(211, 47, 47, 0.1);\n}\n\n.body .tags .tagLists li .remove-tag:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.permission-modal .modal-tags-container label{\n    font-weight: 600;\n    color: #333;\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 10px;\n    margin-top: 0;\n}\n\n.modal-tags-container .tags {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.modal-tags-container .tags .tagLists {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 0;\n    margin: 0;\n}\n\n.modal-tags-container .addbtn{\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-top: 20px;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n/* Tag Dropdown Styles */\n\n.tag-selector-wrapper {\n    display: flex;\n    gap: 15px;\n    align-items: flex-start;\n    margin-top: 10px;\n\n    @media (max-width: 767px) {\n        flex-direction: column;\n        gap: 10px;\n        \n    }\n}\n\n.permission-selector-wrapper{\n    display: flex;\n    gap: 15px;\n    align-items: flex-start;\n    margin-top: 10px;\n    flex-direction: column;\n}\n.permission-dropdown-wrapper{\n    position: relative;\n    width: 100%;\n\n    @media (max-width: 767px) {\n        flex: none;\n        width: 100%;\n    }\n}\n.tag-dropdown-wrapper {\n    position: relative;\n    flex: 0 0 300px;\n    width: 300px;\n\n    @media (max-width: 767px) {\n        flex: none;\n        width: 100%;\n    }\n}\n\n.tag-dropdown-select {\n    width: 100%;\n    height: 50px;\n    border-radius: 10px;\n    border: none;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n    padding: 0 20px;\n    background-color: #fff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #333;\n    box-sizing: border-box;\n}\n\n.tag-dropdown-select:hover {\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-arrow {\n    color: #666;\n}\n\n.permission-dropdown-menu{\n    margin-top: 5px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    max-height: 250px;\n    overflow-y: auto;\n}\n\n.tag-dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    margin-top: 5px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    max-height: 250px;\n    overflow-y: auto;\n    z-index: 1000;\n}   \n\n.tag-dropdown-item {\n    display: flex;\n    align-items: center;\n    padding: 12px 20px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    gap: 10px;\n}\n\n.tag-dropdown-item:hover {\n    background-color: #f5f5f5;\n}\n\n.tag-dropdown-item input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    margin: 0;\n    accent-color: #0A4DA2;\n}\n\n.tag-dropdown-item span {\n    color: #333;\n    font-weight: 500;\n}\n\n/* Inline Tags Display */\n.tags-inline {\n    flex: 1;\n    min-width: 0;\n}\n\n.tags-inline .tagLists {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin: 0;\n    padding: 0;\n}\n\n.tags-inline .tagLists li {\n    list-style: none;\n    font-weight: 500;\n    padding: 8px 12px;\n    border: 1px solid #9b999944;\n    border-radius: 20px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #f5f5f5;\n}\n\n.tags-inline .tagLists li svg {\n    color: #4CAF50;\n    height: 16px;\n    width: 16px;\n}\n\n.tags-inline .tagLists li .remove-tag {\n    background: none;\n    border: none;\n    color: #666;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 4px;\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.3s;\n}\n\n.tags-inline .tagLists li .remove-tag:hover {\n    color: #ff0000;\n}\n\n.modal-tags-container label{\n    margin-top: 50px;\n    font-weight: 600;\n    color: #333;\n    display: flex;\n    align-items: flex-start;\n}\n.modal-tags-container input{\n    height: 50px;\n    border-radius: 30px;\n    border: none;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    width: clamp(200px, 90vw, 670px);\n    /* max-width: 350px; */\n    box-sizing: border-box;\n}\n\n@media (max-width: 480px) {\n    .modal-tags-container .addbtn {\n        flex-direction: column;\n        gap: 10px;\n        margin-top: 10px;\n    }\n\n    .modal-tags-container input {\n        width: 100%;\n        height: 45px;\n        padding: 15px;\n        border-radius: 8px;\n    }\n    \n    .tag-selector-wrapper {\n        flex-direction: column;\n        gap: 10px;\n    }\n    \n    .tag-dropdown-wrapper {\n        flex: none;\n        width: 100%;\n    }\n    \n    .tag-dropdown-select {\n        height: 45px;\n        padding: 0 15px;\n        border-radius: 8px;\n    }\n    \n    .tag-dropdown-menu {\n        max-height: 200px;\n    }\n    \n    .tags-inline {\n        width: 100%;\n    }\n}\n.modal-tags-container .tags .tagLists li {\n    list-style: none;\n    font-weight: 500;\n    padding: 8px 12px;\n    border: 1px solid #9b999944;\n    border-radius: 20px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #f5f5f5;\n}\n\n.modal-tags-container .tags .tagLists li svg {\n    color: #4CAF50;\n    height: 18px;\n    width: 18px;\n}\n\n.modal-tags-container .tags .tagLists li .remove-tag {\n    background: none;\n    border: none;\n    color: #666;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 4px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.3s;\n}\n\n.modal-tags-container .tags .tagLists li .remove-tag:hover {\n    color: #ff0000;\n}\n\n/* Tag Actions Container */\n.tag-actions {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    margin-left: auto;\n}\n\n/* Edit Tag Button */\n.edit-tag-btn {\n    background: none;\n    border: none;\n    color: #0A4DA2;\n    cursor: pointer;\n    padding: 4px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    border-radius: 50%;\n}\n\n.edit-tag-btn:hover {\n    color: #063d7a;\n    background-color: rgba(10, 77, 162, 0.1);\n}\n\n.edit-tag-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Edit Tag Container */\n.edit-tag-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    padding: 2px;\n}\n\n.edit-tag-input {\n    flex: 1;\n    padding: 8px 12px;\n    border: 2px solid #0A4DA2;\n    border-radius: 8px;\n    outline: none;\n    min-width: 120px;\n    font-size: 14px;\n    font-weight: 500;\n    background-color: #fff;\n    transition: all 0.3s ease;\n}\n\n.edit-tag-input:focus {\n    border-color: #063d7a;\n    box-shadow: 0 0 0 3px rgba(10, 77, 162, 0.15);\n    background-color: #f9fbff;\n}\n\n.edit-tag-input:disabled {\n    opacity: 0.6;\n    background-color: #f5f5f5;\n}\n\n.save-edit-btn,\n.cancel-edit-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    border-radius: 4px;\n}\n\n.save-edit-btn {\n    color: #4CAF50;\n}\n\n.save-edit-btn:hover {\n    color: #2e7d32;\n    background-color: rgba(76, 175, 80, 0.1);\n}\n\n.save-edit-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.cancel-edit-btn {\n    color: #f44336;\n}\n\n.cancel-edit-btn:hover {\n    color: #c62828;\n    background-color: rgba(244, 67, 54, 0.1);\n}\n\n.cancel-edit-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.modal-tags-container .tags .tagLists li.editing {\n    padding: 6px 10px;\n    background-color: #f0f7ff;\n    /* border-color: #0A4DA2; */\n}\n\n.body .tags .tagLists li svg{\n    color: #4CAF50;\n    height: 25px;\n    width: 25px;\n}\n\n@media (max-width: 768px) {\n    .body h2 {\n        text-align: center;\n    }\n\n    .body .tags .tagLists {\n        gap: 8px;\n        margin-top: 20px;\n        padding: 0 10px;\n    }\n\n    .body .tags .tagLists li {\n        padding: 8px 12px;\n    }\n\n    .body .tags .tagLists li svg {\n        height: 20px;\n        width: 20px;\n    }\n\n    .modal-tags-container .tags {\n        max-height: 250px;\n    }\n\n    .modal-tags-container .tags .tagLists {\n        gap: 8px;\n    }\n\n    .modal-tags-container .tags .tagLists li {\n        padding: 6px 10px;\n    }\n\n    .modal-tags-container .tags .tagLists li svg {\n        height: 16px;\n        width: 16px;\n    }\n\n    .modal-tags-container .tags .tagLists li .remove-tag {\n        width: 18px;\n        height: 18px;\n    }\n\n    .edit-tag-btn {\n        width: 18px;\n        height: 18px;\n    }\n\n    .edit-tag-input {\n        padding: 5px 8px;\n        min-width: 80px;\n    }\n\n    .save-edit-btn,\n    .cancel-edit-btn {\n    }\n}\n\n    .body .tags .tagLists {\n        gap: 10px;\n        padding: 0 5px;\n    }\n\n    .body .tags .tagLists li {\n        padding: 15px;\n    }\n\n    .modal-tags-container input {\n        height: 40px;\n        padding: 12px;\n    }\n\n    .modal-tags-container .addbtn button {\n        height: 40px;\n    }\n\n    .edit-tag-container {\n        gap: 4px;\n    }\n\n    .edit-tag-input {\n        padding: 4px 6px;\n        min-width: 60px;\n    }\n\n.tag-actions {\n    gap: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
